<template>
  <div class="top-container ivu-menu-horizontal">
    <Row>
      <Col :span="spanLeft">
        <div class="layout-logo">
          <img src="../../../static/images/logo.png" alt="通途ERP">
          <em>LOGI</em>
        </div>
      </Col>
      <Col :span="1" class="layout-hide" v-if="is_register == false">
        <i-button type="text" @click="toggleClick">
          <Icon type="navicon" size="26"></Icon>
        </i-button>
      </Col>
      <Col :span="spanRight" class="layout-menu-span" v-if="is_register == false">
        <Menu mode="horizontal" @on-select="routeTo" :theme="theme1" active-name="0">
          <template v-for="(item, index) in menuMap" :v="index" >
            <template v-if="item.type === 'noSub && item.display'">
              <Menu-item :name="item.id" :v="item.id" class="menuIndex" :key="index">
                {{item.mainTitle}}
              </Menu-item>
            </template>
            <template v-else-if="!item.pid && item.type === 'noGroup' && item.display ">
              <Submenu :name="index" :key="index">
                <template slot="title">
                  {{item.mainTitle}}
                </template>
                <template v-for="(subItem, subIndex) in menuMap">
                  <template v-if="subItem.pid === item.id && subItem.display">
                    <Menu-item :name="item.id + '-' + subItem.id" :v="item.id + '-' + subItem.id" :key="subIndex">
                      {{subItem.mainTitle}}
                    </Menu-item>
                  </template>
                </template>
              </Submenu>
            </template>
            <template v-else-if="item.type === 'Group' && item.display">
              <Submenu :name="index" :key="index">
                <template slot="title">
                  {{item.mainTitle}}
                </template>
                <template v-for="(subItem, subIndex) in menuMap">
                  <template v-if="item.id === subItem.pid">
                    <template v-if="subItem.type === 'Group-title'">
                      <Menu-group :title="subItem.mainTitle" :key="subIndex">
                        <template v-for="dataItem in menuMap">
                          <Menu-item v-if="dataItem.pid === subItem.id && dataItem.display" :name="subItem.id + '-' + dataItem.id" :v="subItem.id + '-' + dataItem.id" :key="dataItem.id">
                            {{dataItem.mainTitle}}
                          </Menu-item>
                        </template>
                      </Menu-group>
                    </template>
                    <template v-else>
                      <Menu-item :name="item.id + '-' + subItem.id" :v="item.id + '-' + subItem.id" :key="subIndex">
                        {{subItem.mainTitle}}
                      </Menu-item>
                    </template>
                  </template>
                </template>
              </Submenu>
            </template>
          </template>
        </Menu>
      </Col>
      <Col :span="1" class="layout-language-icon" :offset="offsetLeft" v-if="is_register == false">
        <Dropdown @on-click="changeLanguage">
          <a href="javascript:;" class="layout-flag-button">
            <div class="flag" :class="flagName"></div>
          </a>
          <Dropdown-menu slot="list">
            <Dropdown-item name="zh-CN">
              <div class="flag zh-CN"></div>简体中文
            </Dropdown-item>
            <Dropdown-item name="zh-TW">
              <div class="flag zh-TW"></div>繁體中文
            </Dropdown-item>
            <Dropdown-item name="en-US">
              <div class="flag en-US"></div>English
            </Dropdown-item>
          </Dropdown-menu>
        </Dropdown>
      </Col>
      <Col :span="1" class="mapContainer" v-if="is_register == false">
        <Poptip v-model="timeZone" placement="bottom" >
          <div class="mapSelect">
          UTC{{UTCtimezoom}}
          </div>
          <div slot="content">
            <Form :label-width="40">
              <Form-item label="时区">
                <Select v-model="timeModal" style="width:250px;" filterable @on-change="changeTimezoom">
                  <Option v-for="(item,index) in timezoomList" :value="item.offset" :key="index">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </Form>
            <div class="timevalue">您当前的时间：{{nowTime}}</div>
            <div class="timevalue">世界标准时间：{{UTCtime}}</div>
          </div>
        </Poptip>
      </Col>
      <Col :span="userSetting" class="layout-user-icon" v-if="is_register == false">
        <Dropdown @on-click="logout">
          <a href="javascript:;">
            <span class="icon iconfont icon-yonghu"></span>
            <!-- Administrator -->
            {{logisSellerUserInfo}}
          </a>
          <Dropdown-menu slot="list">
            <Dropdown-item name="0">
              <div class="lsi-icon">
                <Icon type="log-out"></Icon>
              </div>
              {{$t('common.logout')}}
            </Dropdown-item>
          </Dropdown-menu>
        </Dropdown>
      </Col>
    </Row>
  </div>

</template>
<script>
import layoutMixin from '@/components/mixin/layout_mixin';
import Mixin from '@/components/mixin/common_mixin';
import * as timezoom from '@/assets/timezooms';
import menuLogisticProvider from '@/api/menuLogisticProvider';
import menuOwLogisticProvider from '@/api/menuOwLogisticProvider';
import api from '@/api/api';
export default {
  mixins: [ layoutMixin, Mixin ],
  data () {
    return {
      curWebsiteURL: '', // 当前页面的网址
      logisSellerUserInfo: '', // 物流商和卖家用户信息
      theme1: 'dark',
      menuMap: '',
      flagName: 'zh-CN',
      timeZone: false,
      cacheSpanLeft: this.$store.state.spanLeft,
      timeValue: 8,
      userSetting: this.$store.state.spanLeft < 4 ? 2 : 3,
      offsetLeft: this.$store.state.spanLeft < 4 ? 2 : 1,
      timeModal: '',
      timezoomList: timezoom.timeList,
      nowTime: '',
      is_register:false,
      universalTime: this.getUniversalTime(new Date().getTime(), 'fulltime'),
      thisTime: new Date().getTime(),
      UTCtime: '',
      thisUTCTime: new Date(this.getUniversalTime(new Date(), 'fulltime')).getTime(),
      UTCtimezoom: localStorage.getItem('timezoom') !== undefined ? localStorage.getItem('timezoom') : this.getDefaultTimezoom()
    };
  },
  computed: {
    spanLeft () {
      let fullScreen = this.$store.state.fullScreen;
      if (!fullScreen) {
        return this.$store.state.spanLeft !== 0 ? this.$store.state.spanLeft : 1;
      } else {
        return this.cacheSpanLeft;
      }
    },
    spanRight () {
      let fullScreen = this.$store.state.fullScreen;
      if (!fullScreen) {
        return 17 - this.$store.state.spanLeft;
      } else {
        return 17 - this.cacheSpanLeft;
      }
    },
    fullScreen () {
      return this.$store.state.fullScreen;
    }
  },
  watch: {
    fullScreen (n, o) {
      if (!n) {
        this.cacheSpanLeft = this.$store.state.spanLeft;
      }
    },
    curWebsiteURL (val) {
      let v = this;
      if (val.indexOf('logisicsProvider') > -1) {
        v.getLogisInfo();
      } else if (val.indexOf('seller') > -1) {
        v.getSellerInfo();
      } else if (val.indexOf('admin') > -1) {
        v.logisSellerUserInfo = 'Administrator';
      } else if (val.indexOf('register') > -1 || val.indexOf('findpassword') > -1) {
        v.is_register = true;
        v.toggleClick();
      }
    },
    '$store.state.warehouseList' (val) { // 海外仓数据
      if (val.length) {
        console.log('海外仓数据为:', this.$store.state.warehouseList);
      }
    }
  },
  created () {
    let v = this;
    let lang = localStorage.getItem('lang');
    if (lang !== undefined) {
      v.flagName = lang;
    } else {
      v.flagName = 'zh-CN';
      v.changeLanguage('zh-CN');
    }
    let inGroup = this.$store.state.inGroup;
    v.menuMap = menuLogisticProvider.menu;
    // v.getMenuRole()
    //   .then(response => {
    //     if (response.data.code === 0) {
    //       let roleData = response.data.datas;
    //       v.$store.commit('roleData', roleData);
    //       v.menuMap.forEach((n, i) => {
    //         if (roleData != null) {
    //           roleData.forEach((m, t) => {
    //             n.display = true;
    //           });
    //         }
    //       });
    //     }
    //   });
    v.getLocalTime();
    v.getUTC();
    v.getDefaultTimezoom();
    v.curWebsiteURL = window.location.href;
  },
  methods: { // 方法集
    // 物流商用户信息
    getLogisInfo () {
      let v = this;
      v.axios.post(api.get_memberInfo)
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data !== null) {
              v.logisSellerUserInfo = data.partnerLinkman;
            }
          }
        });
    },
    // 卖家用户信息
    getSellerInfo () {
      let v = this;
      v.axios.post(api.get_sellerMemberInfo)
        .then(res => {
          if (res.data.code === 0) {
            let resData = res.data.datas;
            if (resData !== null) {
              v.logisSellerUserInfo = resData.contactName;
            }
          }
        });
    },
    getMenuRole () {
      // return this.axios.get(api.get_menuRole);
    },
    getLocalTime () {
      let v = this;
      setInterval(function () {
        // v.nowTime = v.getDataToLocalTime(new Date(v.getUniversalTime(new Date(), 'fulltime')).getTime(), 'fulltime');
        let time = v.getDataToLocalTime(new Date(v.getUniversalTime(new Date(), 'fulltime')).getTime(), 'fulltime');
        if (time !== null || time !== '') {
          v.nowTime = time;
        } else {
          v.nowTime = '';
        }
      }, 1000);
    },
    getUTC () {
      let v = this;
      setInterval(function () {
        v.UTCtime = v.getUniversalTime(new Date().getTime(), 'fulltime');
      }, 1000);
    },
    changeTimezoom () {
      let v = this;
      let timeData;
      if (v.timeModal >= 0) {
        timeData = '+' + v.timeModal;
      } else {
        timeData = v.timeModal;
      }
      localStorage.setItem('timezoom', timeData);
      v.$store.commit('timezoomChange', timeData);
      v.UTCtimezoom = timeData;
      v.getNowTime();
    },
    toggleClick () {
      let v = this;
      if (v.$store.state.spanLeft > 1) {
        v.$store.commit('fullScreen', true);
        let tb = document.querySelector('.ivu-table-wrapper .ivu-table-header table');
        let tbody = document.querySelector('.ivu-table-wrapper .ivu-table-body table');
        if (tb) {
          tb.style.width = 100 + '%';
        }
        if (tbody) {
          tbody.style.width = 100 + '%';
        }
      } else {
        v.$store.commit('fullScreen', false);
      }
    },
    changeLanguage (lang) {
      let v = this;
      localStorage.setItem('lang', lang);
      v.flagName = lang;
      window.location.reload();
    },
    close () {
      this.timeZone = false;
    },
    // 登出
    logout () {
      let v = this;
      // console.log('name:', typeof name);
      // console.log('api:', api.logout);
      v.axios.get(api.logout + sessionStorage.getItem('token'))
        .then(response => {
          if (response.data.code === 0) {
            window.location.href = response.data.others.logOutUrl + encodeURIComponent(window.location.href);
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue